import { render } from "./MatchingTable.vue?vue&type=template&id=27180995&scoped=true&ts=true&lang=pug"
import script from "./MatchingTable.vue?vue&type=script&lang=ts"
export * from "./MatchingTable.vue?vue&type=script&lang=ts"

import "./MatchingTable.vue?vue&type=style&index=0&id=27180995&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27180995"]])

export default __exports__